// frontend/src/components/SEO.js
import React from "react";
import { Helmet } from "react-helmet-async";

const CANONICAL_HOST = "www.ojovest.com";

function buildCanonical(path = "/") {
  const cleanPath = path.startsWith("/") ? path : `/${path}`;
  return `https://${CANONICAL_HOST}${cleanPath}`;
}

export default function SEO({
  title = "OjoVest — Premium Wealth Journey",
  description = "Plan SIPs, build mutual fund portfolios, and track progress with clean reporting and tools users understand.",
  path = "/",
  noindex = false,
}) {
  const canonicalUrl = buildCanonical(path);

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:type" content="website" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />

      {noindex && <meta name="robots" content="noindex,nofollow" />}
    </Helmet>
  );
      }
